import * as Action from "@actions/index";

const InitialState = {
  status: "waiting",
  data: null,
  error: null,
};

export default (state = InitialState, action: any): any => {
  switch (action.type) {
    case Action.User.Current.SET_DATA:
      return { ...state, data: action.data };
    case Action.User.Current.SET_STATUS:
      return { ...state, status: action.data };
    case Action.User.Current.SET_ERROR:
      return { ...state, error: action.data };
    case Action.User.Current.CLEAR:
      return { ...state, data: null };
    default:
      return state;
  }
};
